import React from "react";
// import MailApp from "../pages/apps/mail";


import Page from "@jumbo/shared/Page";
import IDS_RefrencesDownload from "./IDS_RefrencesDownload";


import TenantAdminRoute from "../../routes/TenantAdminRoute";

const IDS_routes = [
    {
        path: [
            "ids",
            "/ids/ids-ref",
        ],
        element: <TenantAdminRoute element ={<Page component={IDS_RefrencesDownload}/>} />
    }
    
];

export default IDS_routes;
